// @ts-nocheck
import './AppService/configureAceEditor' // Run this first
import React from 'react'
import Modal from 'react-modal'
import bootbox from 'bootbox'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import update from 'immutability-helper'
import { Integrations } from '@sentry/tracing'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { PersistGate } from 'redux-persist/integration/react'
import { App } from './App.tsx'

import { persistor, store } from './store'

import { unregister as unregisterServiceWorker } from './registerServiceWorker'
// import registerServiceWorker from './registerServiceWorker'
import 'react-app-polyfill/ie11'
import 'url-search-params-polyfill'

import './index.css'
import './lib/jquery'
import 'rc-dropdown/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'
import 'jsondiffpatch/lib/formatters/styles/html.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap'
import { getHistory } from '@features/appRouting'

update.extend('$removeById', (value, original) => original.filter(item => item.id !== value))
update.extend('$removeValue', (value, original) => original.filter(item => item !== value))

Modal.setAppElement('#root')
Modal.defaultStyles.overlay.zIndex = 100

if (import.meta.env.MODE !== 'development' && !window.Cypress) {
  // Sentry frontend tracking
  const { version } = JSON.parse(import.meta.env.REACT_APP_DESIGNER_BUILD_INFO || '{}')
  const release = version?.startsWith('refs/tags/') ? version.replace('refs/tags/', '') : null
  const environment = window.ENVIRONMENT || import.meta.env.MODE || 'production'

  Sentry.init({
    dsn: 'https://1060f99236d04147954ade105b07ee13@o985968.ingest.sentry.io/5942448',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(getHistory())
      }),
      new Sentry.Replay({ maskAllText: false, blockAllMedia: true })
    ],
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    environment,
    release
  })

  // Application Insights frontend tracking - for now use the same instrumentation key for all instances
  window.appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: 'f06e27ea-cd4d-4873-9fed-8b0e80fa1da6',
      disableFetchTracking: false,
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true
    }
  })
  window.appInsights.loadAppInsights()
}

window.Store = store

window.alert = async options => new Promise(resolve => bootbox.alert(options, resolve))

window.confirm = async options =>
  new Promise(resolve => bootbox.confirm(getOptionsWithCallback(options, resolve, 'message')))

window.prompt = async options =>
  new Promise(resolve => bootbox.prompt(getOptionsWithCallback(options, resolve, 'title')))

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// disable because of intentional caching of /handoff route
// registerServiceWorker()
unregisterServiceWorker()

function getOptionsWithCallback(options, resolve, key) {
  if (typeof options !== 'object') {
    options = { [key]: options }
  }

  options.callback = resolve

  return options
}
